import { render, staticRenderFns } from "./tracking-order.vue?vue&type=template&id=bc03d4c8&scoped=true"
import script from "./tracking-order.vue?vue&type=script&lang=js"
export * from "./tracking-order.vue?vue&type=script&lang=js"
import style0 from "./tracking-order.vue?vue&type=style&index=0&id=bc03d4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc03d4c8",
  null
  
)

export default component.exports